import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

/**
 * @description
 * Guard to redirect from old 'water-flow-intelligence' routes to new 'water-track-iq' routes.
 * replaces 'water-flow-intelligence' with 'water-track-iq' in the URL and navigates to the new route.
 * If the URL does not start with 'water-flow-intelligence', navigation is allowed to proceed.
 * 
 * @returns
 * returns false if a redirection occurs, true otherwise.
 */
@Injectable({
    providedIn: 'root'
})
export class wfiRedirectGuard  {
    public constructor(private router: Router) { }

    public canActivate(route: ActivatedRouteSnapshot): boolean {
        const url = route.url.map(segment => segment.path).join('/');
        if (url.startsWith('water-flow-intelligence')) {
            const newUrl = url.replace('water-flow-intelligence', 'water-track-iq');
            void this.router.navigateByUrl(`/${newUrl}`, { replaceUrl: true });
            return false;
        }
        // Allow navigation otherwise
        return true;
    }
}
